import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ManagerRedirect = ({ children }) => {
  const { user } = useAuth();

  // If user is a manager, redirect to invoices instead of dashboard
  if (user?.role === 'manager') {
    return <Navigate to="/admin/invoices" replace />;
  }

  return children;
};

export default ManagerRedirect;

